import { Menu, MenuProps } from "antd";
import Sider from "antd/es/layout/Sider";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import SmallLogo from "../../../assets/images/Favicon.svg";
import MainLogo from "../../../assets/images/main_logo.svg";
import AllSidebarMenu from "../../../constants/AllSidebarMenu";
import { APP_NAME } from "../../../constants/constants";
import {
  activePathString,
  pathString,
  stringToArray,
} from "../../../utils/array";
import Image from "../../ui/Image";

type MenuItem = Required<MenuProps>["items"][number];

type SidebarItemProps = {
  collapsed: boolean;
  openMenuKeys: string[];
  handleOpenMenu: (keys: string[]) => void;
};

export default function SidebarItems({
  collapsed,
  openMenuKeys,
  handleOpenMenu,
}: SidebarItemProps) {
  const location = useLocation();
  // const { siteRole } = useAppSelector((state) => state.login);

  function getItem(
    label: React.ReactNode,
    path: string,
    icon?: React.ReactNode,
    children?: MenuItem[],
    roles?: string[]
  ): MenuItem {
    return {
      key: pathString(path),
      icon,
      children,
      label: children?.length ? label : <Link to={path}>{label}</Link>,
      roles,
    } as MenuItem;
  }

  // filter allowed menu
  // const MenuItems: MenuItem[] = AllSidebarMenu.filter((el) =>
  //   el?.role?.find((rl) => rl === siteRole)
  // ).map(({ name, path, icon: Icon, children }) =>
  //   getItem(
  //     name,
  //     path,
  //     <Icon />,
  //     children?.length
  //       ? children
  //           .filter((el) => el?.role?.find((rl) => rl === siteRole))
  //           .map(({ name: cdName, path: cdPath, icon: CDIcon }) =>
  //             getItem(cdName, cdPath, <CDIcon />)
  //           )
  //       : undefined
  //   )
  // );
  const MenuItems: MenuItem[] = AllSidebarMenu.map(
    ({ name, path, icon: Icon, children }) =>
      getItem(
        name,
        path,
        <Icon />,
        children?.length
          ? children.map(({ name: cdName, path: cdPath, icon: CDIcon }) =>
              getItem(cdName, cdPath, <CDIcon />)
            )
          : undefined
      )
  );

  // find active sub menu
  function getActiveMenu(data: any[]) {
    const strArr = stringToArray(location.pathname, "/");
    return data?.find((el) => el?.key === strArr[1])?.children ? true : false;
  }

  return (
    <Sider
      trigger={null}
      theme="dark"
      collapsible
      collapsed={collapsed}
      className="!h-screen !sticky top-0"
      width={312}
    >
      <div
        className={`h-20 flex items-center sticky top-0 z-50 bg-white ${
          collapsed
            ? "pl-0 justify-center text-center"
            : "pl-5 !justify-start text-start"
        }`}
      >
        <Link to="/admin/dashboard">
          <Image
            height={collapsed ? 35 : 26}
            width="100%"
            src={collapsed ? SmallLogo : MainLogo}
            alt={APP_NAME}
          />
        </Link>
      </div>

      <div className="!overflow-auto h-[calc(100vh-5rem)] !sticky top-0  custom_sidebar custom-scrollbar">
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[
            activePathString(location.pathname, "/", getActiveMenu(MenuItems)),
          ]}
          openKeys={openMenuKeys}
          onOpenChange={handleOpenMenu}
          items={MenuItems}
          className={`sidebar-menu-item ${
            collapsed ? "sidebar_collapsed" : ""
          }`}
        />
      </div>
    </Sider>
  );
}
